import { render } from "./StockSales.vue?vue&type=template&id=18b8859e"
import script from "./StockSales.vue?vue&type=script&lang=js"
export * from "./StockSales.vue?vue&type=script&lang=js"

import "./StockSales.vue?vue&type=style&index=0&id=18b8859e&lang=css"
script.render = render

export default script